import HomePageActionTypes from "./homePage.types"
import { getClass } from "../../Helper";
import uuid from "uuid/v4";
import { API } from "../../API"
import { notify } from "react-notify-toast"
import { createUserObject } from "../../Components-Pages/Profile/profile.utils"

const INITIAL_STATE = {
  user: null,
  sharedProfileTeacherID: null,
  simpleQualifications: []
}

const class_types = getClass();

const homePageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //-------------------- Update in Home2--------------------
    case HomePageActionTypes.UPDATE_TO_ROOT:
      return {
        ...state,
        user: { ...action.payload },
      }

    //-------------------- Deletion in resume--------------------
    case HomePageActionTypes.DELETE_QUALIFICATION:
    case HomePageActionTypes.DELETE_PROFESSIONAL_DEVELOPMENT:
    case HomePageActionTypes.DELETE_PROFESSIONAL_EXPERIENCE:
    case HomePageActionTypes.DELETE_REFEREE_CHECK:
    case HomePageActionTypes.DELETE_NON_TEACHING_EXPERIENCE:
      return {
        ...state,
        //define a function to change the value
        user: deleteOneItemFromResume(state.user, action.payload, action),
      }

    case HomePageActionTypes.DELETE_VET_TRAINING_QUALIFICATION:
    case HomePageActionTypes.DELETE_VET_INDUSTRY_QUALIFICATION:
    case HomePageActionTypes.DELETE_VET_PROFESSIONAL_DEVELOPMENT:
    case HomePageActionTypes.DELETE_VET_TRAINING_EXPERIENCE:
    case HomePageActionTypes.DELETE_VET_INDUSTRY_EXPERIENCE:
    case HomePageActionTypes.DELETE_VET_TRAINER_MATRIX:
      return {
        ...state,
        user: findAndDeleteVetResume(state.user, action)
      }

    //-------------------- Edit and Addmore in resume--------------------
    case HomePageActionTypes.UPDATE_QUALIFICATION:
    case HomePageActionTypes.UPDATE_PROFESSIONAL_DEVELOPMENT:
    case HomePageActionTypes.UPDATE_PROFESSIONAL_EXPERIENCE:
    case HomePageActionTypes.UPDATE_REFEREE_CHECK:
    case HomePageActionTypes.UPDATE_NON_TEACHING_EXPERIENCE:
      return {
        ...state,
        //define a function to change the value
        user: updateFromResume(state.user, action.payload, action),
      }

    case HomePageActionTypes.UPDATE_VET_TRAINING_QUALIFICATION:
    case HomePageActionTypes.UPDATE_VET_INDUSTRY_QUALIFICATION:
    case HomePageActionTypes.UPDATE_VET_PROFESSIONAL_DEVELOPMENT:
    case HomePageActionTypes.UPDATE_VET_TRAINING_EXPERIENCE:
    case HomePageActionTypes.UPDATE_VET_INDUSTRY_EXPERIENCE:
    case HomePageActionTypes.UPDATE_VET_TRAINER_MATRIX:
      return {
        ...state,
        user: findAndUpdateVetResume(state.user, action),
      }

    //-------------------- Add can deliver in profile--------------------
    case HomePageActionTypes.ADD_CAN_DELIVER:
      return {
        ...state,
        //define a function to change the value
        user: addCanDeliverNew(action.payload),
      }
    
    // ------------------- Add can deliver in admin --------------------

    case HomePageActionTypes.ADD_CAN_DELIVER_ADMIN:
      return {
        ...state,
        //define a function to change the value
        user: addCanDeliverAdmin(action.payload, action.payload._id, state.user),
      }

    case HomePageActionTypes.SAVE_SHARE_PROFILE_TEACHER_ID:
      return {
        ...state,
        sharedProfileTeacherID: action.payload,
      }

    //-------------------- Update Personal Detials --------------------
    case HomePageActionTypes.UPDATE_PERSONAL_DETAILS:
      return {
        ...state,
        user: updateDetails(state.user, action.payload, action),
      }

    //---------------------Update Availability-------------------------
    case HomePageActionTypes.UPDATE_AVAILABILITY:
      return {
        ...state,
        user: updateAvailability(action.payload, action),
      }

    //---------------------Job Board
    case HomePageActionTypes.APPLY_TO_LISTING:
      return {
        ...state,
        user: applyToListing(state.user, action.payload.listing_id, action.payload.inst, action.payload.publisher_id)
      }

    case HomePageActionTypes.ADD_FAVOURITE_LISTING:
      return {
        ...state,
        user: addFavouriteListing(state.user, action.payload)
      }

    case HomePageActionTypes.REMOVE_FAVOURITE_LISTING:
      return {
        ...state,
        user: removeFavouriteListing(state.user, action.payload)
      }

    case HomePageActionTypes.UPDATE_SIMPLE_QUALIFICATION:
      return {
        ...state,
        simpleQualifications: action.payload
      }

    default:
      return state
  }
}
export default homePageReducer

//----------------------------------------------------------
//All the utils functions
//----------------------------------------------------------

//Delete one item from Resume
const deleteOneItemFromResume = (user, itemIDToDelete, action) => {
  let msg = ""
  const QUALIFICATION_DELETE_MSG = "Qualification removed successfully"
  const PROFESSIONAL_DEVELOPMENT_DELETE_MSG =
    "Professional development removed successfully"
  const PROFESSIONAL_EXPERIENCE_DELETE_MSG =
    "Professional experience removed successfully"
  const NON_TEACHING_EXPERIENCE_DELETE_MSG =
    "Other experience removed successfully"
  const REFEREE_DELETE_MSG = "Referee removed successfully"
  //Deep copy the user
  const newUser = JSON.parse(JSON.stringify(user))
  switch (action.type) {
    case HomePageActionTypes.DELETE_PROFESSIONAL_DEVELOPMENT:
      // console.log("Now is the delete professional development")
      msg = "Deleted successfully"
      const professionalDevelopmentsArr = newUser.professional_developments.filter(
        (q) => q._id !== itemIDToDelete
      )
      newUser.professional_developments = professionalDevelopmentsArr
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        professional_developments: newUser.professional_developments
      }, msg)
      break

    case HomePageActionTypes.DELETE_QUALIFICATION:
      let qualificationArr;
       msg = "Deleted successfully";
      if (typeof itemIDToDelete === 'object') {
        // Handle VET qualifications
        if (itemIDToDelete.type === 'vet_training_quals') {
          qualificationArr = newUser.vet_training_quals.filter(
            (q) => q._id !== itemIDToDelete.id
          )
          newUser.vet_training_quals = qualificationArr
          sendUserInfoToBackEnd({
            vet_training_quals: newUser.vet_training_quals
          }, msg)
        } else if (itemIDToDelete.type === 'vet_industry_quals') {
          qualificationArr = newUser.vet_industry_quals.filter(
            (q) => q._id !== itemIDToDelete.id
          )
          newUser.vet_industry_quals = qualificationArr
          sendUserInfoToBackEnd({
            vet_industry_quals: newUser.vet_industry_quals
          }, msg)
        }
      } else {
        // Handle regular qualifications
        qualificationArr = newUser.qualifications.filter(
          (q) => q._id !== itemIDToDelete
        )
        newUser.qualifications = qualificationArr
        sendUserInfoToBackEnd({
          qualifications: newUser.qualifications
        }, msg)
      }
      break

    case HomePageActionTypes.DELETE_PROFESSIONAL_EXPERIENCE:
      msg = "Deleted successfully"
      const professionalExperienceArr = newUser.professional_experience.filter(
        (q) => q._id !== itemIDToDelete
      )
      newUser.professional_experience = professionalExperienceArr
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        professional_experience: newUser.professional_experience
      }, msg)
      break

    case HomePageActionTypes.DELETE_REFEREE_CHECK:
      msg = "Deleted successfully"
      const refereesArr = newUser.referees.filter(
        (q) => q._id !== itemIDToDelete
      )
      newUser.referees = refereesArr
      newUser.updateType = "DELETE"
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        referees: newUser.referees
      }, msg)
      break

    case HomePageActionTypes.DELETE_NON_TEACHING_EXPERIENCE:
      msg = "Deleted successfully"
      const nonTeachingExperienceArr = newUser.non_teaching_experience.filter(
        (q) => q._id !== itemIDToDelete
      )
      newUser.non_teaching_experience = nonTeachingExperienceArr
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        non_teaching_experience: newUser.non_teaching_experience
      }, msg)
      break

    default:
  }
  return newUser
}

//Update one item in Resume
const updateFromResume = (user, itemToUpdate, action) => {
  let msg = ""
  let updateType = ""
  let contentID = ""
  let newQualification = {}
  let newProfessionalDevelopment = {}
  let newProfessionalExperience = {}
  let newRefereeCheck = {}
  let newNonTeachingExperience = {}
  const QUALIFICATION_UPDATE_MSG = "Qualification updated successfully"
  const PROFESSIONAL_DEVELOPMENT_UPDATE_MSG =
    "Professional development updated successfully"
  const PROFESSIONAL_EXPERIENCE_UPDATE_MSG =
    "Professional experience updated successfully"
  const NON_TEACHING_EXPERIENCE_UPDATE_MSG =
    "Other experience updated successfully"
  const REFEREE_UPDATE_MSG = "Referee updated successfully"

  //Deep copy the user
  const newUser = JSON.parse(JSON.stringify(user))
  updateType = itemToUpdate.updateType
  newUser.updateType = updateType

  switch (action.type) {
    case HomePageActionTypes.UPDATE_QUALIFICATION:
      // updateType = itemToUpdate.updateType
      newQualification = itemToUpdate.newQualification
      msg = QUALIFICATION_UPDATE_MSG
      if (updateType === "EDIT") {
        contentID = itemToUpdate.content_id
        if (itemToUpdate.type === 'vet_training_quals') {
          newUser.vet_training_quals.forEach((c) => {
            if (c._id === contentID) {
              c.institution_name = newQualification.institution_name
              c.degree = newQualification.degree
              c.major = newQualification.major
              c.qualification_url = newQualification.qualification_url
              c.transcript_url = newQualification.transcript_url
              c.enrolment_url = newQualification.enrolment_url
              c.certificate_filename = newQualification.certificate_filename
              c.transcript_filename = newQualification.transcript_filename
              c.enrolment_filename = newQualification.enrolment_filename
              c.institution_website = newQualification.institution_website
              c.institution_location = newQualification.institution_location
              c.award_name = newQualification.award_name
              c.start_date = newQualification.start_date
              c.graduation_date = newQualification.graduation_date
              c.institution_country = newQualification.institution_country
              c.institution_city = newQualification.institution_city
            }
          })
        } else if (itemToUpdate.type === 'vet_industry_quals') {
          newUser.vet_industry_quals.forEach((c) => {
            if (c._id === contentID) {
              c.institution_name = newQualification.institution_name
              c.degree = newQualification.degree
              c.major = newQualification.major
              c.qualification_url = newQualification.qualification_url
              c.transcript_url = newQualification.transcript_url
              c.enrolment_url = newQualification.enrolment_url
              c.certificate_filename = newQualification.certificate_filename
              c.transcript_filename = newQualification.transcript_filename
              c.enrolment_filename = newQualification.enrolment_filename
              c.institution_website = newQualification.institution_website
              c.institution_location = newQualification.institution_location
              c.award_name = newQualification.award_name
              c.start_date = newQualification.start_date
              c.graduation_date = newQualification.graduation_date
              c.institution_country = newQualification.institution_country
              c.institution_city = newQualification.institution_city
            }
          })
        } else {
          newUser.qualifications.forEach((c) => {
            if (c._id === contentID) {
            c.institution_name = newQualification.institution_name
            c.degree = newQualification.degree
            c.major = newQualification.major
            c.qualification_url = newQualification.qualification_url
            c.transcript_url = newQualification.transcript_url
            c.enrolment_url = newQualification.enrolment_url
            c.certificate_filename = newQualification.certificate_filename
            c.transcript_filename = newQualification.transcript_filename
            c.enrolment_filename = newQualification.enrolment_filename
            c.institution_website = newQualification.institution_website
            c.institution_location = newQualification.institution_location
            c.award_name = newQualification.award_name
            c.start_date = newQualification.start_date
            c.graduation_date = newQualification.graduation_date
            c.institution_country = newQualification.institution_country
            c.institution_city = newQualification.institution_city
            }
          })
        }
      } else if (updateType === "ADD") {
        newUser.qualifications.push(newQualification)
      }
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        qualifications: newUser.qualifications
      }, msg)
      break

    case HomePageActionTypes.UPDATE_PROFESSIONAL_DEVELOPMENT:
      // updateType = itemToUpdate.updateType
      newProfessionalDevelopment = itemToUpdate.newProfDev
      msg = PROFESSIONAL_DEVELOPMENT_UPDATE_MSG
      if (updateType === "EDIT") {
        contentID = itemToUpdate.content_id
        newUser.professional_developments.forEach((c) => {
          if (c._id === contentID) {
            c.activity = newProfessionalDevelopment.activity
            c.location = newProfessionalDevelopment.location
            c.focus_event = newProfessionalDevelopment.focus_event
            c.institution_location =
              newProfessionalDevelopment.institution_location
            c.end_date = newProfessionalDevelopment.end_date
            c.institution_country = newProfessionalDevelopment.institution_country
            c.institution_city = newProfessionalDevelopment.institution_city
          }
        })
      } else if (updateType === "ADD") {
        newUser.professional_developments.push(newProfessionalDevelopment)
      }
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        professional_developments: newUser.professional_developments
      }, msg)
      break

    case HomePageActionTypes.UPDATE_PROFESSIONAL_EXPERIENCE:
      // updateType = itemToUpdate.updateType
      newProfessionalExperience = itemToUpdate.newProfExperience
      msg = PROFESSIONAL_EXPERIENCE_UPDATE_MSG
      if (updateType === "EDIT") {
        contentID = itemToUpdate.content_id
        newUser.professional_experience.forEach((c) => {
          if (c._id === contentID) {
            c.organisation = newProfessionalExperience.organisation
            c.institution_location =
              newProfessionalExperience.institution_location
            c.course_class_delivered =
              newProfessionalExperience.course_class_delivered
            c.start_date = newProfessionalExperience.start_date
            c.end_date = newProfessionalExperience.end_date
            c.other_referee_first_name =
              newProfessionalExperience.referee_first_name
            c.other_referee_last_name =
              newProfessionalExperience.referee_last_name
            c.other_referee_email = newProfessionalExperience.referee_email
            c.other_referee_position_title =
              newProfessionalExperience.referee_position_title
            c.institution_country = newProfessionalExperience.institution_country
            c.institution_city = newProfessionalExperience.institution_city
          }
        })
      } else if (updateType === "ADD") {
        newUser.professional_experience.push(newProfessionalExperience)
      }

      if (!newUser.can_delivers) {
        newUser.can_delivers = createUserObject(newUser, true);
      }
      newProfessionalExperience.course_class_delivered.forEach((new_cd) => {
        const class_type = class_types.find(cl => cl.key === new_cd.value) || { type: [] }
        class_type.type.forEach(cat => {
          if (!cat.includes("exp")) {
            if (!newUser.can_delivers[cat]) {
              newUser.can_delivers[cat] = []
            }
            if (!newUser.can_delivers[cat].includes(class_type.key)) {
              newUser.can_delivers[cat].push(class_type.key)
            }
          }
        })
      })
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        professional_experience: newUser.professional_experience,
        can_delivers: newUser.can_delivers
      }, msg)
      break

    case HomePageActionTypes.UPDATE_REFEREE_CHECK:
      // updateType = itemToUpdate.updateType
      newRefereeCheck = itemToUpdate.newRefereeCheck
      msg = REFEREE_UPDATE_MSG
      if (updateType === "EDIT") {
        contentID = itemToUpdate.content_id
        newUser.referees.forEach((c) => {
          if (c._id === contentID) {
            c.organisation = newRefereeCheck.organisation
            c.referee_first_name = newRefereeCheck.referee_first_name
            c.referee_last_name = newRefereeCheck.referee_last_name
            c.referee_email = newRefereeCheck.referee_email
            c.referee_position_title = newRefereeCheck.referee_position_title
            c.flag = newRefereeCheck.flag
          }
        })
      } else if (updateType === "ADD") {
        newUser.referees.push(newRefereeCheck)
      }
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        referees: newUser.referees
      }, msg)
      break

    case HomePageActionTypes.UPDATE_NON_TEACHING_EXPERIENCE:
      // updateType = itemToUpdate.updateType
      newNonTeachingExperience = itemToUpdate.newNonTeachingExperience
      msg = NON_TEACHING_EXPERIENCE_UPDATE_MSG
      console.log(newNonTeachingExperience)
      if (updateType === "EDIT") {
        contentID = itemToUpdate.content_id
        newUser.non_teaching_experience.forEach((c) => {
          if (c._id === contentID) {
            c.organisation = newNonTeachingExperience.organisation
            c.institution_location =
              newNonTeachingExperience.institution_location
            c.role_held = newNonTeachingExperience.role_held
            c.main_duties = newNonTeachingExperience.main_duties
            c.start_date = newNonTeachingExperience.start_date
            c.end_date = newNonTeachingExperience.end_date
            c.other_referee_first_name =
              newNonTeachingExperience.other_referee_first_name
            c.other_referee_last_name =
              newNonTeachingExperience.other_referee_last_name
            c.other_referee_email = newNonTeachingExperience.other_referee_email
            c.other_referee_position_title =
              newNonTeachingExperience.other_referee_position_title
            c.institution_country = newNonTeachingExperience.institution_country
            c.institution_city = newNonTeachingExperience.institution_city
          }
        })
      } else if (updateType === "ADD") {
        newUser.non_teaching_experience.push(newNonTeachingExperience)
      }
      // updateNewUserToBackEnd(newUser, msg)
      sendUserInfoToBackEnd({
        non_teaching_experience: newUser.non_teaching_experience
      }, msg)
      break
    default:
  }
  return newUser
}

const copyVetQualification = (currQual, newQual) => {
  currQual.institution_name = newQual.institution_name
  currQual.degree = newQual.degree
  currQual.major = newQual.major
  currQual.qualification_url = newQual.qualification_url
  currQual.transcript_url = newQual.transcript_url
  currQual.enrolment_url = newQual.enrolment_url
  currQual.certificate_filename = newQual.certificate_filename
  currQual.transcript_filename = newQual.transcript_filename
  currQual.enrolment_filename = newQual.enrolment_filename
  currQual.institution_website = newQual.institution_website
  currQual.institution_location = newQual.institution_location
  currQual.award_name = newQual.award_name
  currQual.start_date = newQual.start_date
  currQual.graduation_date = newQual.graduation_date
  currQual.institution_country = newQual.institution_country
  currQual.institution_city = newQual.institution_city
}

const persistVetQualData = (newUser, payload, vet_data, message) => {
  let updateType = ""
  let contentID = ""
  let newQualification = {}

  updateType = payload.updateType
  newQualification = payload.newQualification

  if (updateType === "EDIT") {
    contentID = payload.content_id
    vet_data.forEach((item) => {
      if (item._id === contentID) {
        copyVetQualification(item, newQualification)
      }
    })
  } else if (updateType === "ADD") {
    vet_data.push(newQualification)
  }

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_training_quals: newUser.vet_training_quals
  }, message)
}

const persistVetIndusQualData = (newUser, payload, vet_data, message) => {
  let updateType = ""
  let contentID = ""
  let newQualification = {}

  updateType = payload.updateType
  newQualification = payload.newQualification

  if (updateType === "EDIT") {
    contentID = payload.content_id
    vet_data.forEach((item) => {
      if (item._id === contentID) {
        copyVetQualification(item, newQualification)
      }
    })
  } else if (updateType === "ADD") {
    vet_data.push(newQualification)
  }

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_industry_quals: newUser.vet_industry_quals
  }, message)
}

const persistVetProfDev = (newUser, payload, message) => {
  const updateType = payload.updateType
  const newProfDev = payload.newProfDev

  if (updateType === "EDIT") {
    const contentID = payload.content_id
    newUser.vet_pd.forEach((item) => {
      if (item._id === contentID) {
        item.activity = newProfDev.activity
        item.location = newProfDev.location
        item.focus_event = newProfDev.focus_event
        item.institution_location = newProfDev.institution_location
        item.end_date = newProfDev.end_date
        item.institution_country = newProfDev.institution_country
        item.institution_city = newProfDev.institution_city
      }
    })
  } else if (updateType === "ADD") {
    newUser.vet_pd.push(newProfDev)
  }

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_pd: newUser.vet_pd
  }, message)
}

const persistVetExp = (newUser, payload, vet_data, message) => {
  const updateType = payload.updateType
  const newProfExperience = payload.newProfExperience

  if (updateType === "EDIT") {
    const contentID = payload.content_id
    vet_data.forEach((item) => {
      if (item._id === contentID) {
        item.organisation = newProfExperience.organisation
        item.institution_location = newProfExperience.institution_location
        item.course_class_delivered = newProfExperience.course_class_delivered
        item.role_held = newProfExperience.role_held
        item.start_date = newProfExperience.start_date
        item.end_date = newProfExperience.end_date
        item.other_referee_first_name = newProfExperience.referee_first_name
        item.other_referee_last_name = newProfExperience.referee_last_name
        item.other_referee_email = newProfExperience.referee_email
        item.other_referee_position_title = newProfExperience.referee_position_title
        item.institution_city = newProfExperience.institution_city
        item.institution_country = newProfExperience.institution_country
      }
    })
  } else if (updateType === "ADD") {
    vet_data.push(newProfExperience)
  }

  if (!newUser.can_delivers) {
    newUser.can_delivers = createUserObject(newUser, true);
  }

  newProfExperience.course_class_delivered.forEach((new_cd) => {
    const class_type = class_types.find(cl => cl.key === new_cd.value)
    class_type.type.forEach(cat => {
      if (!cat.includes("exp")) {
        if (!newUser.can_delivers[cat]) {
          newUser.can_delivers[cat] = []
        }
        if (!newUser.can_delivers[cat].includes(class_type.key)) {
          newUser.can_delivers[cat].push(class_type.key)
        }
      }
    })
  })

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_training_exp: newUser.vet_training_exp,
    can_delivers: newUser.can_delivers
  }, message)
}

const persistVetIndusExp = (newUser, payload, vet_data, message) => {
  const updateType = payload.updateType
  const newProfExperience = payload.newProfExperience

  if (updateType === "EDIT") {
    const contentID = payload.content_id
    vet_data.forEach((item) => {
      if (item._id === contentID) {
        item.organisation = newProfExperience.organisation
        item.institution_location = newProfExperience.institution_location
        item.course_class_delivered = newProfExperience.course_class_delivered
        item.role_held = newProfExperience.role_held
        item.start_date = newProfExperience.start_date
        item.end_date = newProfExperience.end_date
        item.other_referee_first_name = newProfExperience.referee_first_name
        item.other_referee_last_name = newProfExperience.referee_last_name
        item.other_referee_email = newProfExperience.referee_email
        item.other_referee_position_title = newProfExperience.referee_position_title
        item.institution_city = newProfExperience.institution_city
        item.institution_country = newProfExperience.institution_country
      }
    })
  } else if (updateType === "ADD") {
    vet_data.push(newProfExperience)
  }

  if (!newUser.can_delivers) {
    newUser.can_delivers = createUserObject(newUser, true);
  }

  newProfExperience.course_class_delivered.forEach((new_cd) => {
    const class_type = class_types.find(cl => cl.key === new_cd.value)
    class_type.type.forEach(cat => {
      if (!cat.includes("exp")) {
        if (!newUser.can_delivers[cat]) {
          newUser.can_delivers[cat] = []
        }
        if (!newUser.can_delivers[cat].includes(class_type.key)) {
          newUser.can_delivers[cat].push(class_type.key)
        }
      }
    })
  })

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_industry_exp: vet_data,
    can_delivers: newUser.can_delivers
  }, message)
}

const persistVetMatrix = (newUser, payload, message) => {
  const updateType = payload.updateType
  const newMatrix = payload.newMatrix

  if (updateType === "ADD") {
    newUser.vet_matrix.push(newMatrix)
  }

  // updateNewUserToBackEnd(newUser, message)
  sendUserInfoToBackEnd({
    vet_matrix: newUser.vet_matrix
  }, message)
}

const findAndUpdateVetResume = (user, action) => {
  const TRAINING_QUAL_UPDATE_MSG = "Training Qualification updated successfully"
  const INDUSTRY_QUAL_UPDATE_MSG = "Industry Qualification updated successfully"
  const PROFESSIONAL_DEVELOPMENT_UPDATE_MSG = "Professional Development updated successfully"
  const TRAINING_EXPERIENCE_UPDATE_MSG = "Training experience updated successfully"
  const INDUSTRY_EXPERIENCE_UPDATE_MSG = "Industry experience updated successfully"
  const TRAINER_MATRIX_UPDATE_MSG = "Trainer matrix updated successfully"

  const newUser = JSON.parse(JSON.stringify(user))
  switch (action.type) {
    case HomePageActionTypes.UPDATE_VET_TRAINING_QUALIFICATION:
      persistVetQualData(newUser, action.payload, newUser.vet_training_quals, TRAINING_QUAL_UPDATE_MSG)
      break

    case HomePageActionTypes.UPDATE_VET_INDUSTRY_QUALIFICATION:
      persistVetIndusQualData(newUser, action.payload, newUser.vet_industry_quals, INDUSTRY_QUAL_UPDATE_MSG)
      break

    case HomePageActionTypes.UPDATE_VET_PROFESSIONAL_DEVELOPMENT:
      persistVetProfDev(newUser, action.payload, PROFESSIONAL_DEVELOPMENT_UPDATE_MSG)
      break

    case HomePageActionTypes.UPDATE_VET_TRAINING_EXPERIENCE:
      persistVetExp(newUser, action.payload, newUser.vet_training_exp, TRAINING_EXPERIENCE_UPDATE_MSG)
      break

    case HomePageActionTypes.UPDATE_VET_INDUSTRY_EXPERIENCE:
      persistVetIndusExp(newUser, action.payload, newUser.vet_industry_exp, INDUSTRY_EXPERIENCE_UPDATE_MSG)
      break

    case HomePageActionTypes.UPDATE_VET_TRAINER_MATRIX:
      persistVetMatrix(newUser, action.payload, TRAINER_MATRIX_UPDATE_MSG)
      break

    default:
  }

  return newUser
}

const filterVetData = (arrayVal, id) => {
  const filtered = arrayVal.filter((item) => item._id !== id)
  return filtered
}

const findAndDeleteVetResume = (user, action) => {
  const DELETE_MSG = "Deleted successfully"

  const newUser = JSON.parse(JSON.stringify(user))
  let newInfo = null
  switch (action.type) {
    case HomePageActionTypes.DELETE_VET_TRAINING_QUALIFICATION:
      newUser.vet_training_quals = filterVetData(newUser.vet_training_quals, action.payload)
      newInfo = {
        vet_training_quals: newUser.vet_training_quals
      }
      break

    case HomePageActionTypes.DELETE_VET_INDUSTRY_QUALIFICATION:
      newUser.vet_industry_quals = filterVetData(newUser.vet_industry_quals, action.payload)
      newInfo = {
        vet_industry_quals: newUser.vet_industry_quals
      }
      break

    case HomePageActionTypes.DELETE_VET_PROFESSIONAL_DEVELOPMENT:
      newUser.vet_pd = filterVetData(newUser.vet_pd, action.payload)
      newInfo = {
        vet_pd: newUser.vet_pd
      }
      break

    case HomePageActionTypes.DELETE_VET_TRAINING_EXPERIENCE:
      newUser.vet_training_exp = filterVetData(newUser.vet_training_exp, action.payload)
      newInfo = {
        vet_training_exp: newUser.vet_training_exp
      }
      break

    case HomePageActionTypes.DELETE_VET_INDUSTRY_EXPERIENCE:
      newUser.vet_industry_exp = filterVetData(newUser.vet_industry_exp, action.payload)
      newInfo = {
        vet_industry_exp: newUser.vet_industry_exp
      }
      break

    case HomePageActionTypes.DELETE_VET_TRAINER_MATRIX:
      newUser.vet_matrix = filterVetData(newUser.vet_matrix, action.payload)
      newInfo = {
        vet_matrix: newUser.vet_matrix
      }
      break

    default:
  }

  // updateNewUserToBackEnd(newUser, DELETE_MSG)
  sendUserInfoToBackEnd(newInfo, DELETE_MSG)
  return newUser
}

// add can deliver in the profile
const addCanDeliver = (userToAdd) => {
  const newUser = JSON.parse(JSON.stringify(userToAdd))
  const msg = "Can deliver updated successfully"
  // updateNewUserToBackEnd(newUser, msg)
  sendUserInfoToBackEnd({
    can_delivers: newUser.can_delivers
  }, msg)
  return newUser
}

const addCanDeliverAdmin = (userToAdd, userID, currentUser) => {
  const newUser = JSON.parse(JSON.stringify(userToAdd))
  const msg = "Can deliver updated successfully"
  // updateUserInfoFromAdmin({can_delivers: newUser.can_delivers}, userID, msg)
  updateUserInfoFromAdmin({selected_can_delivers: newUser.selected_can_delivers}, userID, msg)
  return currentUser
}

const addCanDeliverNew = (userToAdd) => {
  const newUser = JSON.parse(JSON.stringify(userToAdd))
  const msg = "Can deliver updated successfully"
  // updateNewUserToBackEnd(newUser, msg)
  sendUserInfoToBackEnd({
    selected_can_delivers: newUser.selected_can_delivers
  }, msg)
  return newUser
}

// // check if an can_deliver is in the calss_types
// const findCanDeliver = (cd) => {
//   let result = {}
//   class_types.forEach((c_type) => {
//     if (c_type.key === cd.value) {
//       result = c_type
//     }
//   })
//   return result
// }

// // generate a can_Deliver object (not sure why we need the other fields, though)
// const setCanDeliver = (cd, c) => {
//   return {
//     _id: uuid(),
//     can_deliver: cd.value,
//     bg_color: c.bg_color,
//     whole_name: c.whole_name,
//     short_name: c.short_name,
//   }
// }

// // whether a can_deliver is in the list already
// const isDuplicated = (cd, list) => {
//   let result = false
//   list.forEach((item) => {
//     if (cd.value === item.can_deliver) {
//       result = true
//     }
//   })
//   return result
// }


// update user features
const FEATURE_UPDATE_MSG = "User details updated successfully"

const updateDetails = (user, details, action) => {
  if (action.type !== HomePageActionTypes.UPDATE_PERSONAL_DETAILS) {
    return user
  }
  const newUser = Object.assign({}, user, details)
  const msg = FEATURE_UPDATE_MSG
  // updateNewUserToBackEnd(newUser, msg)
  sendUserInfoToBackEnd(details, msg)
  return newUser
}


/**
 * Unused from July, 2023. This flow now use sendAvailability function
 */
const updateAvailability = (user, action) => {
  if (action.type !== HomePageActionTypes.UPDATE_AVAILABILITY) {
    return user
  }
  const newUser = Object.assign({}, user)
  const msg = "Availability updated successfully"
  // updateNewUserToBackEnd(newUser, msg)
  return newUser
}

// put the modified user into the backend
const updateNewUserToBackEnd = async (user, msg) => {
  // await API.updateUser({ user: user })
  //   .then((res) => {
  //     notify.show(msg, "custom", 2000, { background: '#FFFFFF', text: "	#000000" })
  //   })
  //   .catch((err) => {
  //     console.log(err)
  //   })
  return user
}

/**
 * This function is developed to replace the updateNewUserToBackEnd function to: 
 * only update necessary information (field(s)) instead of sending the whole user object to the server
 * Developed: July 12th, 2023 by Jude Nguyen
 * @param {*} payload 
 * @param {*} msg 
 */
const sendUserInfoToBackEnd = async (payload, msg) => {
  await API.updateUserInfo(payload)
    .then((res) => {
      if ("is_show_progress_bar" in payload) return

      notify.show(msg, "custom", 2000, { background: '#FFFFFF', text: "	#000000" })
    })
    .catch((err) => {
      console.log(err)
    })
}

const updateUserInfoFromAdmin = (payload, userID, msg) => {
  API.updateUserInfoByAdmin(payload, userID).then((res) => {
    notify.show(msg, "custom", 2000, { background: '#FFFFFF', text: "	#000000" });
  }).catch((err) => {
    console.log(err);
  })
}

const applyToListing = (user, listing_id, inst, publisher_id) => {
  let new_applications = [...user.my_applications];
  new_applications.push({
    date: new Date(),
    listing_id,
  });

  return {
    ...user,
    my_applications: new_applications
  }
}

const addFavouriteListing = (user, listing_id) => {
  API.saveAsFavourite(listing_id, user._id)
    .then(res => {
      notify.show("Listing added to favourites")
    })
    .catch(err => {
      console.log(err.response)
      notify.show("Error updating favourites")
    })

  let fav_listings = [...user.my_favourites]
  fav_listings.push({
    date: new Date(),
    listing_id,
  })

  return {
    ...user,
    my_favourites: fav_listings
  }
}

const removeFavouriteListing = (user, listing_id) => {
  let fav_listings = [...user.my_favourites]
  fav_listings = fav_listings.filter(listing => listing.listing_id !== listing_id)

  API.removeFromFavourite(listing_id, user._id)
    .then(res => {
      notify.show("Listing removed from favourites")
    })
    .catch(err => {
      console.log(err.response)
      notify.show("Error updating favourites")
    })

  return {
    ...user,
    my_favourites: fav_listings
  }
}
